"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const calculate_total_known_shares_1 = __importDefault(require("@App/helpers/work-entities/utils/calculate-total-known-shares"));
const contexts_1 = require("@App/contexts");
const PublisherRemainingShareCount = () => {
    const { workStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const outstandingShares = 100 - (0, calculate_total_known_shares_1.default)(workStore.workDraftLocal);
    return (react_1.default.createElement("div", { className: 'publisher-remaining-share-count' },
        "A maximum of",
        ' ',
        react_1.default.createElement("span", { className: "blue-text bold" },
            Math.max(Math.trunc(outstandingShares * 100) / 100, 0),
            "%"),
        " of shares may be claimed"));
};
exports.default = PublisherRemainingShareCount;
